export function formatFeetInches(value) {
  if (value === null || value === undefined) return "";
  let s = String(value).trim();
  if (!s) return "";

  // Normalize curly quotes.
  s = s.replace(/[’‘]/g, "'").replace(/[”“]/g, '"').trim();

  // If already includes feet marker, just ensure we end with inches marker.
  if (s.includes("'")) {
    // Remove any trailing inch marks; we'll add a single one back if appropriate.
    const withoutInchMark = s.replace(/"+\s*$/g, "").trim();
    const parts = withoutInchMark.split("'");
    const feetPart = parts[0]?.trim();
    const inchesPart = (parts.slice(1).join("'") || "").trim();

    // If it's malformed (no feet digits), fall back to original.
    if (!/^\d+$/.test(feetPart)) return s;

    // If inches are empty, treat as 0.
    const inchesRaw = inchesPart === "" ? "0" : inchesPart;

    // Only add inches marker when inches look numeric-ish (e.g. 7, 7.25).
    if (/^\d+(\.\d+)?$/.test(inchesRaw)) return `${feetPart}'${inchesRaw}"`;
    return s;
  }

  // Try to parse common "feet inches" patterns missing the apostrophe:
  // "6-3", "6 3", "6 3.5", "6-3.25"
  const m = s.match(/^(\d+)\s*[-\s]\s*([\d.]+)\s*"?$/);
  if (m) {
    const feet = m[1];
    const inches = m[2];
    return `${feet}'${inches}"`;
  }

  return s;
}

/** Format feet+inches for measurement tables (heights, wingspan, standing reach). */
export function formatMeasurementFeetInches(value, empty = "--") {
  const formatted = formatFeetInches(value);
  return formatted || empty;
}

export function feetInchesToInchesSafe(value) {
  const formatted = formatFeetInches(value);
  if (!formatted) return 0;
  const m = formatted.match(/^(\d+)'\s*([\d.]+)"/);
  if (!m) return 0;
  const feet = parseInt(m[1], 10);
  const inches = parseFloat(m[2]);
  if (Number.isNaN(feet) || Number.isNaN(inches)) return 0;
  return feet * 12 + inches;
}

